/* eslint-disable */


/**
 * Create styles for `<AccountDetails />`
 * @param {any} theme The theme
 * @returns The `<AccountDetails />` styles
 */
const accountDetailsStyles = ({ theme }) => {
  return {
    iconContainer: {
      width: 56,
    },
    iconSpacing: {
      paddingLeft: theme.spacing(1) * 7,
    },
    subheading: {
      marginBottom: theme.spacing(1) * 2,
    },
  };
};

export default accountDetailsStyles;
